import React from 'react'

import clsx from 'clsx'

const CardMedia = ({ children, className, ...props }) => {
  return (
    <div className={clsx('CardMedia', className)} {...props}>
      {children}
    </div>
  )
}

export default CardMedia
